import React from 'react';
import styled, { css } from 'styled-components';

import Checkbox from '@ui-elements/Checkbox';

import { SPEPANE_AMSWER_LIST } from '~/constants';
import { PALETTE } from '~/assets/styles/base';

type FlexWrapperProps = {
  $choiceCnt: number;
};

const FlexWrapper = styled.div<FlexWrapperProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${({ $choiceCnt }) => ($choiceCnt < 3 ? 'space-between' : 'space-evenly')};
  // 業種の時だけflexを縦方向に変更。
  ${({ $choiceCnt }) =>
    $choiceCnt > 15 &&
    /* istanbul ignore next */
    css`
      flex-direction: column;
      max-height: 550px;
    `}
`;

type WrapperProps = {
  $twoCol: boolean;
  $choiceCnt: number;
};

const Wrapper = styled.div<WrapperProps>`
  width: ${({ $twoCol, $choiceCnt }) => (!$twoCol || $choiceCnt < 3 ? '500px' : '800px')};
`;

type InnerProps = {
  $choiceCnt: number;
};

const Inner = styled.div<InnerProps>`
  width: ${({ $choiceCnt }) => ($choiceCnt < 3 ? '75%' : '100%')};
  margin: ${({ $choiceCnt }) => ($choiceCnt < 3 ? '0 auto' : '0')};
`;

type CheckBoxWrapperProps = {
  $twoCol: boolean;
  $choiceCnt: number;
};

// 選択肢の数によってスタイルを変更
const CheckBoxWrapper = styled.div<CheckBoxWrapperProps>`
  flex: ${({ $twoCol }) => ($twoCol ? '50%' : '100%')};
  ${({ $choiceCnt }) =>
    $choiceCnt < 3 &&
    css`
      flex: none;
    `}
  border-bottom: ${({ $choiceCnt }) =>
    $choiceCnt < 3 ? 'none' : `1px solid ${PALETTE.border.modalItemBottom}`};
`;

type Props = {
  choices: { [key: string]: boolean };
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleChange: Function;
  twoCol?: boolean;
  specialPanelDisplaySettingId?: number;
};

const SpecialPanelChoicesCheckBoxes: React.FC<Props> = ({
  choices,
  handleChange,
  twoCol = false,
  specialPanelDisplaySettingId,
}): JSX.Element => {
  const choiceCnt = Object.keys(choices).length;
  return (
    <Wrapper $twoCol={twoCol} $choiceCnt={choiceCnt}>
      <Inner $choiceCnt={choiceCnt}>
        {choices && (
          <FlexWrapper $choiceCnt={choiceCnt}>
            {Object.entries(choices).map(([choiceId, isChecked]) => (
              <CheckBoxWrapper
                key={choiceId}
                $twoCol={twoCol}
                $choiceCnt={choiceCnt}
                data-testid={`uiParts-SpepaneWrapper-${choiceId}`}
              >
                {specialPanelDisplaySettingId && (
                  <Checkbox
                    name={choiceId}
                    label={
                      (
                        (SPEPANE_AMSWER_LIST as Record<number, Record<string, string>>)[
                          specialPanelDisplaySettingId
                        ] as Record<string, string>
                      )[choiceId]
                    }
                    value=""
                    checked={isChecked}
                    handleChange={(e) => handleChange(e, choiceId)}
                    dataTestId={choiceId}
                  />
                )}
              </CheckBoxWrapper>
            ))}
          </FlexWrapper>
        )}
      </Inner>
    </Wrapper>
  );
};

export default SpecialPanelChoicesCheckBoxes;
